const initialState = {
    alertMessage: "",
    showAlert: false,
    alertType: "alert alert-primary alert-dismissible fade show"
};

export default function alertReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_ALERT_MESSAGE':
            return {
                ...state,
                alertMessage: action.payload
            };
        case 'SHOW_ALERT':
            return {
                ...state,
                showAlert: true
            };
        case 'HIDE_ALERT':
            return {
                ...state,
                showAlert: false
            };
        case 'SET_ALERT_TYPE_PRIMARY':
            return {
                ...state,
                alertType: "alert alert-primary alert-dismissible fade show"
            };
        case 'SET_ALERT_TYPE_DANGER':
            return {
                ...state,
                alertType: "alert alert-danger alert-dismissible fade show"
            };
        default:
            return state;
    }
}